import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, throwError } from 'rxjs';

import { SOURCE_TYPE } from '../constants/Tpiq.constants';
import { Session } from '../services/Session';
import { TaxplanIQServices } from '../services/TaxplanIQServices';

@Injectable({ providedIn: 'root' })
export class ProjectionsHandoffService extends TaxplanIQServices {
  constructor(http: HttpClient) {
    super(http);
  }

  createRedirect(): Observable<string> {
    const userEmail = Session.getUser()?.id;
    const firmId = this.resolveFirmId();
    if (!userEmail || !firmId) {
      return throwError(() => new Error('Missing user/firm context'));
    }

    const url = '/TaxPlanningServices/handoff-to-projections?userId=' + encodeURIComponent(userEmail)
      + '&firmId=' + encodeURIComponent(firmId);

    return this.query(url, SOURCE_TYPE.JAVA).pipe(map((response: { redirectUrl: string }) => {
      if (!response?.redirectUrl) {
        throw new Error('No redirect URL returned');
      }
      return response.redirectUrl;
    }));
  }

  private resolveFirmId(): string | null {
    const host = window.location.hostname;
    const subdomain = host.split('.')[0];
    const firmFromDomain = host.endsWith('taxplaniq.com')
      && subdomain !== 'app'
      && subdomain !== 'stag-app'
      ? subdomain
      : null;
    return firmFromDomain ?? Session.getOrg();
  }
}
